<script lang="ts" setup>
import { useLiveCasinoFilter } from '~/composables/game/use-live-casino-filter'

const {
  changeCategory,
  onClickProvider,
  getProviderImage,
  currentProvider,
  providerOptions,
  categoryOptions,
} = useLiveCasinoFilter()

const lobbyGameRefFilter = ref<HTMLDivElement | null>(null)

const { isVisible: isHeaderVisible } = useHiddenToScroll({ defaultValue: true })
</script>
<template>
  <div class="live-casino">
    <div class="container">
      <div class="live-casino__banner">
        <h2 class="live-casino__title">Live Casino</h2>
        <p class="live-casino__description">Dealer sexy - Bàn chơi đa dạng</p>
      </div>
    </div>
    <CommonCasinoLivestream />
  </div>
  <div
    class="container filter-sticky"
    :style="{
      top: isHeaderVisible ? '54px' : 0,
    }"
  >
    <form ref="lobbyGameRefFilter" class="live-casino__filter-game" action="#">
      <FormDropdown
        :options="providerOptions"
        :clearable="false"
        name="provider"
        content-class="casino-providers-filter"
        scroll-behavior="close"
      >
        <template #item="{ item, props: itemProps }">
          <div
            :class="[
              'item-dropdown',
              'bank-dropdown-item',
              {
                'bank-dropdown-item--selected':
                  currentProvider === item.raw.key,
              },
              { 'bank-dropdown-item--hidden': item.value === '' },
            ]"
            v-bind="itemProps"
            title=""
            @click="onClickProvider(item.raw.key)"
          >
            <img
              class="logo-casino-provider"
              :alt="item.title"
              :src="
                getProviderImage(
                  currentProvider === item.raw.key
                    ? `${item.value}-active-dropdown`
                    : `${item.raw.icon}-dropdown`,
                )
              "
            />
            <span class="bank-dropdown-item__title line-limit-1">{{
              item.title
            }}</span>
          </div>
        </template>
        <template #selection="{ item }">
          <div class="bank-dropdown-selection-item">
            <img
              class="logo-casino-provider"
              :alt="item.title"
              :src="getProviderImage(`${item.value}-active-dropdown`)"
            />
            <span class="bank-dropdown-selection-item__title line-limit-1">{{
              item.title
            }}</span>
          </div>
        </template>
      </FormDropdown>
      <FormDropdown
        name="category"
        content-class="casino-category-filter"
        :options="categoryOptions"
        scroll-behavior="close"
        @on-model-change="changeCategory"
      />
    </form>
  </div>
</template>
<style scoped lang="scss">
@import '/assets/styles/components/mobile/pages/live-casino/filter.scss';
</style>
